<script>
export default {
    props: {
        leases: {
            type: Array,
            default: () => []
        },
        paginator: {
            type: Object,
            default: () => ({})
        },
        meta: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        hasPassed(lease) {
            if (!lease.land_lease_deadlines) return false;
            return lease.land_lease_deadlines.some(
                dl => !dl.completed && dl.deadline_status === "passed"
            );
        },
        hasWarning(lease) {
            if (!lease.land_lease_deadlines) return false;
            return lease.land_lease_deadlines.some(
                dl => !dl.completed && dl.deadline_status === "warning"
            );
        }
    }
};
</script>

<template>
    <div>
        <div class="table-responsive">
            <v-table class="table table-mg table-sm table-hover">
                <v-thead>
                    <v-tr>
                        <v-th v-if="false">
                            <v-sorter
                                :paginator="paginator"
                                name="LandLeases.id"
                                @sort="$emit('sort', $event)"
                            >
                                ID
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="paginator"
                                name="LandLeases.lease_type"
                                @sort="$emit('sort', $event)"
                            >
                                {{ $t("land_leases.hdr_type") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="paginator"
                                name="LandLeases.party_name"
                                @sort="$emit('sort', $event)"
                            >
                                {{ $t("land_leases.hdr_party") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="paginator"
                                name="LandLeases.party_type"
                                @sort="$emit('sort', $event)"
                            >
                                {{ $t("land_leases.hdr_party_type") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="paginator"
                                name="Projects.title"
                                @sort="$emit('sort', $event)"
                            >
                                {{ $t("land_leases.hdr_project") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="paginator"
                                name="Users.name"
                                @sort="$emit('sort', $event)"
                            >
                                {{ $t("land_leases.hdr_pm") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="paginator"
                                name="LandLeases.status"
                                @sort="$emit('sort', $event)"
                            >
                                {{ $t("land_leases.hdr_status") }}
                            </v-sorter>
                        </v-th>
                        <v-th class="text-center">
                            {{ $t("land_leases.hdr_obs") }}
                        </v-th>
                        <v-th class="text-right"></v-th>
                    </v-tr>
                </v-thead>
                <v-tbody>
                    <v-tr
                        v-for="lease in leases"
                        :key="lease.id"
                        class="m-click"
                        @click.native="$emit('view', lease)"
                    >
                        <v-td v-if="false">{{ lease.id }}</v-td>
                        <v-td>
                            <span class="text-primary">
                                {{ lease.lease_type_name }}
                            </span>
                        </v-td>
                        <v-td>{{ lease.party_name }}</v-td>
                        <v-td>{{ lease.party_type_name }}</v-td>
                        <v-td>
                            <template v-if="lease.project">
                                {{ lease.project.title }}
                            </template>
                        </v-td>
                        <v-td>
                            <template v-if="lease.user">
                                {{ lease.user.name }}
                            </template>
                        </v-td>
                        <v-td>{{ lease.status_name }}</v-td>
                        <v-td class="text-center">
                            <i
                                v-if="hasPassed(lease)"
                                class="fas fa-circle text-danger"
                            ></i>
                            <i
                                v-if="hasWarning(lease)"
                                class="fas fa-circle text-warning"
                            ></i>
                        </v-td>
                        <v-td class="text-right">
                            <i
                                class="far fa-pencil fa-lg m-click text-primary"
                                @click.stop="$emit('edit', lease)"
                            ></i>
                        </v-td>
                    </v-tr>
                </v-tbody>
            </v-table>
        </div>
        <div class="paginator" v-if="meta.pagination">
            <base-pagination
                :page-count="meta.pagination.total_pages"
                :per-page="meta.pagination.per_page"
                :value="meta.pagination.current_page"
                @input="$emit('paginate', $event)"
            />
        </div>
    </div>
</template>
